export default {
  SET_RENDER_STATUS: '@WS/SET_RENDER_STATUS',
};
